module.exports = __webpack_public_path__ + "media/images/powered-by-rkd-a5594a17.png";